import { CouponErrorFields } from 'components/coupon/couponCreation/CouponHandleError';
import { VALID_PERIOD_TYPE } from 'models/CreateCouponModel';

const ticketBaseInfoValidate = ({ getValues, prefix = ""}) => {
  const [
    name,
    coverPhoto,
  ] = getValues([
    `${prefix}translations.en.name`,
    `${prefix}translations.en.coverPhoto`,
  ]);
  const errorList = [];

  if (!name || name.length > 200) {
    errorList.push({
      name: `${prefix}translations.en.name`,
      message: CouponErrorFields.generalName.message,
    });
  }
  if (!coverPhoto) {
    errorList.push({
      name: `${prefix}translations.en.coverPhoto`,
      message: CouponErrorFields.coverPhotoEmpty.message,
    });
  }
  return errorList
}

export const couponCodeValidate = ({
  getValues,
  prefix = "",
}) => {
  const [
    validPeriodType,
    absoluteEffectiveDate,
    absoluteExpiryDate,
  ] = getValues([
    `${prefix}validPeriodType`,
    `${prefix}absoluteEffectiveDate`,
    `${prefix}absoluteExpiryDate`,
  ]);

  let errorList = [];
  if (
    validPeriodType === VALID_PERIOD_TYPE.ABSOLUTE &&
    absoluteExpiryDate <= absoluteEffectiveDate
  ) {
    errorList.push({
      name: `${prefix}absoluteExpiryDate`,
      message: CouponErrorFields.endDatetime.message,
    });
  }
  return errorList
}

const additionalDataValidate = ({
  getValues,
  prefix = "",
}) => {
  const [
    additionalData,
  ] = getValues([
    `${prefix}additionalData`,
  ]);

  let errorList = [];

  for (const [index, additionalItem] of (additionalData || []).entries()) {
    if (additionalItem.title || !additionalItem.value) {
      continue
    }
    errorList.push({
      name: `${prefix}additionalData.${index}.title`,
      message: CouponErrorFields.additionalDataTitle.message,
    });
  }
  return errorList
}

const firstStepValidate = ({ getValues, setError }) => {
  const [
    selectedBrand,
    ticketStore,
  ] = getValues([
    'selectedBrand',
    'ticketStore',
  ]);

  let errorList = [
    ...ticketBaseInfoValidate({
      getValues,
      prefix: "",
    }),
    ...additionalDataValidate({ getValues }),
    ...couponCodeValidate({ getValues }),
  ]

  if (!selectedBrand) {
    errorList.push({
      name: 'selectedBrand',
      message: CouponErrorFields.brand.message,
    });
  }

  if (!ticketStore?.pk) {
    errorList.push({
      name: 'ticketStore',
      message: CouponErrorFields.applicationStore.message,
    });
  }


  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
}

export function ticketCreationValidate({
  getValues,
  setError,
  clearErrors,
}) {
  clearErrors();

  return firstStepValidate({ getValues, setError })
}